import { useLayoutEffect, useRef } from 'react';

const NotificationToastContent = ({
  title,
  message,
  visualToken,
  onOverflow
}) => {
  const messageRef = useRef(null);

  useLayoutEffect(() => {
    const messageNode = messageRef.current;
    if (!messageNode) return undefined;

    let mounted = true;
    const reportOverflow = () => {
      if (
        mounted
        && messageNode.scrollHeight > messageNode.clientHeight
      ) {
        onOverflow?.(visualToken);
      }
    };

    reportOverflow();
    const resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(reportOverflow)
      : null;
    resizeObserver?.observe(messageNode);

    return () => {
      mounted = false;
      resizeObserver?.disconnect();
    };
  }, [message, onOverflow, visualToken]);

  return (
    <div className="shuttle-notification-content">
      {title && (
        <div className="shuttle-notification-title">{title}</div>
      )}
      <div
        ref={messageRef}
        className="shuttle-notification-message"
        tabIndex={0}
      >
        {message}
      </div>
    </div>
  );
};

export default NotificationToastContent;
